import NamedDto from 'modules/base/dto/NamedDto';

export class OptimizationCaseTransformerAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _OptimizationCaseTransformerAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _OptimizationCaseTransformerAttributeEditDtoProps} OptimizationCaseTransformerAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {OptimizationCaseTransformerAttributeEditDtoProps} props
	 * @returns {OptimizationCaseTransformerAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.value = props.value;
		return this;
	}
}

export default OptimizationCaseTransformerAttributeEditDto;
